export function createAuthLifecycle() {
  let revision = 0
  return {
    snapshot: () => revision,
    isCurrent: (value) => value === revision,
    invalidate: () => { revision += 1 },
  }
}

export async function logoutLocally({ lifecycle, request, clear, redirect }) {
  lifecycle.invalidate()
  const revision = lifecycle.snapshot()
  await request()
  if (!lifecycle.isCurrent(revision)) return
  clear()
  redirect()
}
